import { useEffect } from "react";
import { useApi } from "./useApi"; // هوک API
import {
  fetchLaw,
  fetchRefreshToken,
  fetchMogharare,
  fetchRay,
  fetchComment,
  fetchReportStatistic,
} from "./../components/api/api"; // فانکشن‌های API
import { useDataContext } from "../context/subContexts/DataContext";
import { useAuthContext } from "../context/subContexts/AuthContext";
import { jwtDecode } from "jwt-decode";

export const useCheckToken = () => {
  const { continuee, setContinuee,tokenLogin,email } = useAuthContext();

  const { callApi: callApiLaw } = useApi(fetchLaw,"fetchLaw",[]);
  const { callApi: callApiRefToken } = useApi(fetchRefreshToken,"fetchRefreshToken",[],true);
  const { callApi: callApiMogharare } = useApi(fetchMogharare,"fetchMogharare",[]);
  const { callApi: callApiFetchRay } = useApi(fetchRay,"fetchRay",[]);
  const { callApi: callApiFetchComment } = useApi(fetchComment,"fetchComment",[]);
  //const { callApi: callApiFetchReportStatistic } = useApi(fetchReportStatistic);

  const isTokenExpired = (tokenProp) => {
    try {
      const decoded = jwtDecode(tokenProp);
      if (decoded.exp < Date.now() / 1000) {
        return true;
      } else return false;
    } catch (err) {
      return false;
    }
  };
   const checkContinue = () => {
      if (isTokenExpired(tokenLogin?.accessTokenExpiration)) {
        if (isTokenExpired(tokenLogin?.refreshTokenExpiration)) {
          setContinuee(true);
  
          // localStorage.setItem("edame", JSON.stringify(edame));
          localStorage.clear();
        } else {
          // console.log("edame with refreshToken");
  
          callApiRefToken(tokenLogin,email);
        }
      } else {
        try {
          // console.log("check edame true ");
          // localStorage.setItem("edame", JSON.stringify(edame));
        } catch (error) {
          console.log("errorFetchAllData222222222222", error);
        }
      }
    };

  useEffect(() => {
    if (!tokenLogin || !tokenLogin.accessToken) return;
    console.log("success");

    if (isTokenExpired(tokenLogin?.accessTokenExpiration)) {
      if (isTokenExpired(tokenLogin?.refreshTokenExpiration)) {
        setContinuee(true);
        // localStorage.setItem("edame", JSON.stringify(false));
        localStorage.clear();
      } else {
        callApiRefToken();
      }
    } else {
      try {
        callApiLaw();
        callApiMogharare();
        callApiFetchRay();
        callApiFetchComment();
        //callApiFetchReportStatistic();
        // fetchSub()
      } catch (error) {
        console.log("errorFetchAllData", error);
      }
    }
  }, [tokenLogin, continuee]);
  return {checkContinue}
};
